export const assessments = {
  week1: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What is the definition of Resilience?",
        options: [
          { id: "A", text: "The ability to avoid challenges." },
          { id: "B", text: "The ability to bounce back after facing a challenge." },
          { id: "C", text: "The ability to solve every problem perfectly." },
          { id: "D", text: "The ability to never make mistakes." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "What is the difference between resilience and grit?",
        options: [
          { id: "A", text: "Resilience is about giving up, and grit is about never trying." },
          { id: "B", text: "Resilience is bouncing back from challenges, while grit is sticking with something even when it’s difficult." },
          { id: "C", text: "Grit is only for sports, and resilience is only for school." },
          { id: "D", text: "Grit is about avoiding challenges, and resilience is about ignoring difficulties." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question: "Which statement reflects a growth mindset?",
        options: [
          { id: "A", text: "I can’t do this, and I’ll never be able to." },
          { id: "B", text: "I can’t do this yet, but I’ll get better with practice." },
          { id: "C", text: "I’m already good at everything, so I don’t need to try." },
          { id: "D", text: "If I fail, it means I’m not good enough." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "What does the ‘Power of Yet’ mean?",
        options: [
          { id: "A", text: "You can do everything perfectly without practice." },
          { id: "B", text: "You may not be able to do something now, but with effort, you will improve over time." },
          { id: "C", text: "You should avoid difficult tasks until you feel ready." },
          { id: "D", text: "You’re stuck with your current abilities, and nothing will change." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question: "Which of the following is an example of using grit?",
        options: [
          { id: "A", text: "Giving up after failing once." },
          { id: "B", text: "Trying different strategies after struggling with a problem." },
          { id: "C", text: "Only working on things that are easy for you." },
          { id: "D", text: "Quitting when things get difficult." },
        ],
        correctOption: "B",
      },
    ],
  },
  week2: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What does Competence refer to in the 7 C’s of Resilience?",
        options: [
          { id: "A", text: "Believing in yourself and your abilities." },
          { id: "B", text: "Building skills and solving problems." },
          { id: "C", text: "Managing stressful situations." },
          { id: "D", text: "Contributing to your community." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "Which of the following best describes the “Control” component of resilience?",
        options: [
          { id: "A", text: "Having confidence in your abilities." },
          { id: "B", text: "Being able to control everything around you." },
          { id: "C", text: "Understanding what you can and can’t change." },
          { id: "D", text: "Taking responsibility for others’ emotions." },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question: "If you’re feeling nervous before a test and decide to take a few deep breaths to calm down, which of the 7 C’s are you using?",
        options: [
          { id: "A", text: "Coping." },
          { id: "B", text: "Character." },
          { id: "C", text: "Contribution." },
          { id: "D", text: "Connections." },
        ],
        correctOption: "A",
      },
      {
        id: 4,
        question: "Why is “Connections” important for resilience?",
        options: [
          { id: "A", text: "It helps you handle stress by avoiding other people." },
          { id: "B", text: "It reminds you that you’re not alone and can rely on support." },
          { id: "C", text: "It teaches you to manage everything on your own." },
          { id: "D", text: "It gives you control over other people’s emotions." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question: "Which “C” involves understanding your values and using them to guide your decisions, even in tough times?",
        options: [
          { id: "A", text: "Competence." },
          { id: "B", text: "Coping." },
          { id: "C", text: "Character." },
          { id: "D", text: "Confidence." },
        ],
        correctOption: "C",
      },
    ]
  },
  week3: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "Tolu is described as adaptable. This means she?",
        options: [
          { id: "A", text: "Is able to change who you are when challenges arise." },
          { id: "B", text: "Resists changes to maintain stability." },
          { id: "C", text: "Adjusts to new situations or challenges while staying true to herself." },
          { id: "D", text: "Ignores problems and hope they go away." },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question: "Which of the following is an example of adaptability?",
        options: [
          { id: "A", text: "Sticking to your original plan even if things go wrong." },
          { id: "B", text: "Trying a new study method when your usual one isn’t working." },
          { id: "C", text: "Getting frustrated when plans change." },
          { id: "D", text: "Avoiding new experiences to stay comfortable." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question: "Why is adaptability important for resilience?",
        options: [
          { id: "A", text: "It helps you avoid change altogether." },
          { id: "B", text: "It teaches you to be less emotional." },
          { id: "C", text: "It allows you to handle unexpected changes and grow from them." },
          { id: "D", text: "It ensures that everything goes according to plan." },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question: "What should you do when you face a sudden, unexpected challenge?",
        options: [
          { id: "A", text: "Panic and immediately give up." },
          { id: "B", text: "Take a deep breath, assess the situation, and find a solution." },
          { id: "C", text: "Blame others for the problem." },
          { id: "D", text: "Stick to your usual way of doing things without considering new ideas." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question: "How can you practice adaptability in your daily life?",
        options: [
          { id: "A", text: "By avoiding new experiences to prevent discomfort." },
          { id: "B", text: "By staying rigid in your mindset to maintain control." },
          { id: "C", text: "By trying new hobbies or handling changes in plans calmly." },
          { id: "D", text: "By only focusing on tasks you already know how to do." },
        ],
        correctOption: "C",
      },
    ]
    ,
  },
  week4: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        "id": 1,
        "question": "What is a support system?",
        "options": [
          { "id": "A", "text": "A group of people who always agree with everything you do." },
          { "id": "B", "text": "The people who help you stay strong and bounce back during tough times." },
          { "id": "C", "text": "A system that prevents you from making mistakes." },
          { "id": "D", "text": "A place where you can find advice on all life’s problems." }
        ],
        "correctOption": "B"
      },
      {
        "id": 2,
        "question": "Why are support systems important for resilience?",
        "options": [
          { "id": "A", "text": "They solve your problems for you." },
          { "id": "B", "text": "They give you the strength and encouragement to face challenges." },
          { "id": "C", "text": "They make decisions on your behalf." },
          { "id": "D", "text": "They avoid making you feel stressed." }
        ],
        "correctOption": "B"
      },
      {
        "id": 3,
        "question": "Which of the following is an effective way to build a strong support system?",
        "options": [
          { "id": "A", "text": "Spending time with people who care about you." },
          { "id": "B", "text": "Relying only on yourself to handle challenges." },
          { "id": "C", "text": "Keeping your emotions to yourself to avoid burdening others." },
          { "id": "D", "text": "Trying to handle everything alone without asking for help." }
        ],
        "correctOption": "A"
      },
      {
        "id": 4,
        "question": "Why is asking for help a sign of strength?",
        "options": [
          { "id": "A", "text": "It shows that you don’t know how to solve problems." },
          { "id": "B", "text": "It means you’re weak and can’t handle things on your own." },
          { "id": "C", "text": "It demonstrates that you recognize your limits and are willing to grow with the help of others." },
          { "id": "D", "text": "It makes people do your work for you." }
        ],
        "correctOption": "C"
      },
      {
        "id": 5,
        "question": "What is a practical way to strengthen your support system?",
        "options": [
          { "id": "A", "text": "Keep all your struggles to yourself." },
          { "id": "B", "text": "Offer support to others when they need it." },
          { "id": "C", "text": "Only seek help from others when you’re forced to." },
          { "id": "D", "text": "Avoid joining any groups or clubs." }
        ],
        "correctOption": "B"
      }
    ],
  },
  week5: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        "id": 1,
        "question": "What are coping skills?",
        "options": [
          { "id": "A", "text": "Strategies to avoid stress." },
          { "id": "B", "text": "Techniques that help deal with stress, anxiety, and challenges." },
          { "id": "C", "text": "Ways to prevent problems from happening." },
          { "id": "D", "text": "Methods to blame others for problems." }
        ],
        "correctOption": "B"
      },
      {
        "id": 2,
        "question": "Which of the following is considered a healthy coping skill?",
        "options": [
          { "id": "A", "text": "Avoiding problems." },
          { "id": "B", "text": "Yelling." },
          { "id": "C", "text": "Deep breathing." },
          { "id": "D", "text": "Overeating." }
        ],
        "correctOption": "C"
      },
      {
        "id": 3,
        "question": "Journaling your thoughts when you are anxious or troubled can help you become calm and more aware of your emotions.",
        "options": [
          { "id": "A", "text": "False" },
          { "id": "B", "text": "True" }
        ],
        "correctOption": "B"
      },
      {
        "id": 4,
        "question": "What is one example of a creative outlet that can help with stress?",
        "options": [
          { "id": "A", "text": "Watching TV." },
          { "id": "B", "text": "Playing a musical instrument." },
          { "id": "C", "text": "Scrolling through social media." },
          { "id": "D", "text": "Sleeping." }
        ],
        "correctOption": "B"
      },
      {
        "id": 5,
        "question": "What should you do if a coping skill doesn't work for you?",
        "options": [
          { "id": "A", "text": "Give up and ignore the problem." },
          { "id": "B", "text": "Try a different coping skill that might work better." },
          { "id": "C", "text": "Blame others for your stress." },
          { "id": "D", "text": "Stop trying to cope with the problem." }
        ],
        "correctOption": "B"
      },
      {
        "id": 6,
        "question": "Why is grit important for success?",
        "options": [
          { "id": "A", "text": "It makes challenges disappear." },
          { "id": "B", "text": "It helps you stay focused and persistent, even when things are tough." },
          { "id": "C", "text": "It allows you to avoid difficult situations." },
          { "id": "D", "text": "It makes you smarter than everyone else." }
        ],
        "correctOption": "B"
      },
      {
        "id": 7,
        "question": "Which of the following is an example of a resilient action?",
        "options": [
          { "id": "A", "text": "Giving up after failing a test." },
          { "id": "B", "text": "Asking for help and studying harder after a setback." },
          { "id": "C", "text": "Blaming someone else for your failure." },
          { "id": "D", "text": "Ignoring the problem and hoping it goes away." }
        ],
        "correctOption": "B"
      },
      {
        "id": 8,
        "question": "How does the 'Power of Yet' mindset help you overcome challenges?",
        "options": [
          { "id": "A", "text": "It makes you believe that challenges are impossible." },
          { "id": "B", "text": "It reminds you that even if you can’t do something now, you have the potential to achieve it with effort and time." },
          { "id": "C", "text": "It encourages you to quit if something is too hard." },
          { "id": "D", "text": "It teaches you to ignore failure." }
        ],
        "correctOption": "B"
      }, 
      {
        "id": 9,
        "question": `What should you consider when building your personal "Coping Toolbox"?`,
        "options": [
          { "id": "A", "text": "Only use coping skills that work for your friends." },
          { "id": "B", "text": "Experiment with different coping strategies to find what works best for you and keep those strategies handy." },
          { "id": "C", "text": "Avoid trying new coping skills." },
          { "id": "D", "text": "Use coping strategies only when you have no other option." }
        ],
        "correctOption": "B"
      },
      {
        "id": 10,
        "question": "What is an example of a positive coping strategy when you're feeling sad?",
        "options": [
          { "id": "A", "text": "Isolating yourself from everyone." },
          { "id": "B", "text": "Writing in a journal about your thoughts and feelings." },
          { "id": "C", "text": "Pretending nothing is wrong." },
          { "id": "D", "text": "Keep talking." }
        ],
        "correctOption": "B"
      },
    ],
  }
};
